import {
  reactive,
  onBeforeMount,
  computed,
  getCurrentInstance,
  watch,
  ref,
} from "@vue/composition-api";
import store from "@/store";
import router from "@/router";

import useDynamicFields from "@/views/components/dynamic-fields/hooks/useDynamicFields";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import usePagination from "@/views/components/pagination/usePagination";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import { bannerCriteria } from "@/models/banner/banner";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";

export default function useBannerCriteria(props) {
  const vm = getCurrentInstance().proxy;
  const {
    fetchBannerCriteriaList,
    editBannerCriteria,
    removeBannerCriteria,
    createBannerCriteria,
  } = bannerCriteria();

  const {
    pagination,
    paginationInfo,
    onPageChange,
    onFilterEntity,
  } = usePagination();

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();

  const { openModal, closeModal } = useModal();

  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const loading = reactive({
    tableField: false,
    tableData: false,
  });

  const formData = reactive({
    bannerId: 0,
    critiriaTable: [],
  });

  const criteriaItem = reactive({
    bannerId: 0,
    selectId: 0,
  });

  const dataTableList = reactive({
    dataList: [
      {
        priority: 1,
        name: "test",
        list: "",
        updatetime: "",
      },
      {
        priority: 2,
        name: "test2",
        list: "",
        updatetime: "",
      },
    ],
  });

  const isEditCriteria = ref(false);

  const modalType = reactive({
    manageCriteria: false,
  });

  const fields = reactive({
    criteriaTable: [
      { key: "priority", label: "Priority" },
      { key: "name", label: "Name" },
      { key: "list", label: "List" },
      { key: "updatedtime", label: "Lastest Update" },
      { key: "actions", label: "" },
    ],
  });

  const criteriaListTable = reactive({
    payload: [],
  });

  const onSaveCriteria = (inputData, isEditModal = false) => {
    if (!props.isEdit && router.currentRoute.query.bannerId)
      formData.bannerId = router.currentRoute.query.bannerId;

    window.$loading(true);
    const payload = {
      BannerId: formData.bannerId,
      Name: inputData.name,
      Priority: inputData.priority,
      Note: inputData.note,
    };

    createBannerCriteria.payload = payload;
    editBannerCriteria.payload = payload;

    let payloadParam = {};

    if (isEditModal) {
      editBannerCriteria.payload.Criteria_GroupId = inputData.criteriaGroupId;

      payloadParam = editBannerCriteria;
    } else {
      createBannerCriteria.payload.Req_IdentityId = 1;
      createBannerCriteria.payload.TagList = inputData.tag;

      createBannerCriteria.payload.TagList =
        inputData.tag.length > 0
          ? inputData.tag.map((o, index) => ({
              Seq: index + 1,
              Tag: o.label,
              Condition: "AND",
              GroupLv: 1,
              GroupNum: 1,
            }))
          : [];
      payloadParam = createBannerCriteria;
    }

    store
      .dispatch("api/apiRequest", payloadParam)
      .then((resp) => {
        modalType.manageCriteria = false;
        closeModal();
        fetchBannerCriteriaTableList();
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const fetchBannerCriteriaTableList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchBannerCriteriaList.payload.BannerId = formData.bannerId;
    fetchBannerCriteriaList.payload.Page = pagination.currentPage;
    fetchBannerCriteriaList.payload.Limit = pagination.perPage;
    fetchBannerCriteriaList.payload.Filters = filters;
    fetchBannerCriteriaList.payload.Ordering = ordering.value;

    store
      .dispatch("api/apiRequest", fetchBannerCriteriaList)
      .then((response) => {
        formData.critiriaTable = [];
        if (response.data) {
          formData.critiriaTable = response.data
            ? Object.values(response.data.payload).sort(
                (a, b) => b.priority - a.priority
              )
            : [];

          pagination.rows = formData.critiriaTable.length;
          pagination.totalRows = response.data ? response.data.filtered_record : 0;
        }
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const openCriteriaModal = (selectId, isEdit = false) => {
    isEditCriteria.value = false;
    if (selectId) criteriaItem.selectId = selectId;
    if (isEdit == true) {
      isEditCriteria.value = true;
    }
    criteriaItem.bannerId = formData.bannerId;
    modalType.manageCriteria = true;
    openModal();
  };

  const closeCriteriaModal = () => {
    modalType.manageCriteria = false;
    closeModal();
  };

  const openDeleteWarningModal = (itemData) => {
    openWarningModal(
      "ลบ Criteria",
      `ต้องการลบ ${itemData.name} หรือไม่`,
      () => {
        removeCriteria(itemData.criteria_groupid);
      }
    );
  };

  const removeCriteria = (id) => {
    window.$loading(true);
    removeBannerCriteria.payload.Criteria_GroupId = id; // required

    store
      .dispatch("api/apiRequest", removeBannerCriteria)
      .then((response) => {
        openSuccessModal(
          "ทำรายการสำเร็จ !",
          null,
          "ตกลง",
          () => {
            vm.$nextTick(() => {
              fetchBannerCriteriaTableList();
            });
          },
          () => {
            vm.$nextTick(() => {
              fetchBannerCriteriaTableList();
            });
          }
        );
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  const onSubmit = () => {
    openSuccessModal(
        'ทำรายการสำเร็จ !',
        undefined,
        undefined,
        undefined,
        navigateToBannerListPage
      )
  }

  const navigateToBannerListPage = () => {
    router.push("/banner/list/Banner_List");
  };

  const checkFormCreateOrEdit = () => {
    if (router.currentRoute.params.bannerId) {
      vm.$emit("onGetBannerId", parseInt(router.currentRoute.params.bannerId));
    }
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchBannerCriteriaTableList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchBannerCriteriaTableList();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    checkFormCreateOrEdit();
    if (props.bannerId || props.isEdit) {
      formData.bannerId = props.bannerId;
      fetchBannerCriteriaTableList();
    }
  });

  return {
    loading,
    fields,
    formData,
    criteriaListTable,
    pagination,
    paginationInfo,
    onPageChange,
    onFilterEntity,
    isEditCriteria,
    modalType,
    openCriteriaModal,
    closeCriteriaModal,
    openDeleteWarningModal,
    criteriaItem,
    onSaveCriteria,
    onSubmit
  };
}
